export default "__VITE_ASSET__DFGg7N3G__"